import {
  CHECKOUT_SUBMIT,
  CHECKOUT_SUBMIT_ERROR,
  CHECKOUT_SET_CUSTOMER_INFO,
  CHECKOUT_SET_DISCOUNT_CODE,
  CHECKOUT_SET_DELIVERY,
  CHECKOUT_SET_PAYMENT,
  CHECKOUT_SET_ORDER_NOTE,
  CHECKOUT_ACCEPT_CREATE_ACCOUNT,
  CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
  CHECKOUT_ACCEPT_NEWSLETTER,
  CHECKOUT_CREATE_ACCOUNT,
  CHECKOUT_SET_PRIVATE_CUSTOMER,
  CHECKOUT_SET_PAYMENT_WIDGET,
  CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
  CHECKOUT_SET_SIGN_UP,
  CHECKOUT_SET_COUNTRY,
  CHECKOUT_SET_USED_DISCOUNT_CODE,
  CLEAR_ERRORS,
  STORE_PICKUP_SET_ZIPCODE,
  STORE_PICKUP_SET_LOCATIONS,
  STORE_PICKUP_SET_SELECTED_LOCATION,
  STORE_PICKUP_SET_CUSTOMER_INFO,
  STORE_PICKUP_PREFILL_CUSTOMER_INFO,
  STORE_PICKUP_SET_LOADING,
  STORE_PICKUP_SET_ERRORS,
  STORE_PICKUP_SUBMIT,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultStorePickup = {
  zipCode: '',
  pickupLocations: [],
  selectedPickupLocation: null,
  customerInfo: {
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    address: '',
    postalCode: '',
    city: '',
    socialSecurity: '',
    companyName: '',
    organizationNumber: '',
    orderNote: '',
    acceptTermsOfCondition: false,
  },
  isLoading: false,
  isSubmitting: false,
  errors: {},
  result: null,
};

const defaultState = {
  payload: {
    alternativeAddress: {},
    customerDetails: {},
    selectedCompanyAddressId: null,
    selectedDeliveryMethod: {},
    selectedPaymentMethod: {},
    selectedCountry: {},
    discountCode: '',
    orderNote: {},
    paymentWidget: null,
    isBusinessCustomer: false,
    signUp: false,
    acceptTermsOfCondition: false,
    acceptAccount: false,

    authenticated: false,
    deliveryMethods: [],
    paymentMethods: [],
    companyAddresses: [],
    responseUrl: '',
    cancelUrl: '',
    redirectUrl: '',
  },
  errors: {},
  result: {},
  isSubmitting: false,
  storePickup: defaultStorePickup,
};

export const checkout = (preloadedState = defaultState, action) => {
  const state = {
    ...preloadedState,
    storePickup: preloadedState.storePickup || defaultStorePickup,
  };
  const { type, payload } = action;

  switch (type) {
    case CHECKOUT_SUBMIT_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    case CLEAR_ERRORS:
    case CHECKOUT_SUBMIT:
      return {
        ...state,
        ...payload,
      };
    case CHECKOUT_SET_CUSTOMER_INFO:
      return {
        ...state,
        payload: {
          ...state.payload,
          [payload.key]: {
            ...state.payload[payload.key],
            ...payload.data,
          },
        },
      };
    case CHECKOUT_SET_DELIVERY:
    case CHECKOUT_SET_PAYMENT:
    case CHECKOUT_SET_ORDER_NOTE:
    case CHECKOUT_SET_PAYMENT_WIDGET:
    case CHECKOUT_SET_PRIVATE_CUSTOMER:
    case CHECKOUT_SET_SIGN_UP:
    case CHECKOUT_SET_SELECTED_COMPANY_ADDRESS:
    case CHECKOUT_ACCEPT_TERMS_OF_CONDITION:
    case CHECKOUT_CREATE_ACCOUNT:
    case CHECKOUT_SET_DISCOUNT_CODE:
    case CHECKOUT_SET_COUNTRY:
    case CHECKOUT_ACCEPT_CREATE_ACCOUNT:
    case CHECKOUT_ACCEPT_NEWSLETTER:
    case CHECKOUT_SET_USED_DISCOUNT_CODE:
      return {
        ...state,
        payload: {
          ...state.payload,
          ...payload,
        },
      };
    case STORE_PICKUP_SET_ZIPCODE:
    case STORE_PICKUP_SET_LOCATIONS:
    case STORE_PICKUP_SET_SELECTED_LOCATION:
    case STORE_PICKUP_SET_LOADING:
    case STORE_PICKUP_SET_ERRORS:
    case STORE_PICKUP_SUBMIT:
      return {
        ...state,
        storePickup: {
          ...state.storePickup,
          ...payload,
        },
      };
    case STORE_PICKUP_SET_CUSTOMER_INFO:
      return {
        ...state,
        storePickup: {
          ...state.storePickup,
          customerInfo: {
            ...state.storePickup.customerInfo,
            [payload.field]: payload.value,
          },
        },
      };
    case STORE_PICKUP_PREFILL_CUSTOMER_INFO:
      return {
        ...state,
        storePickup: {
          ...state.storePickup,
          customerInfo: {
            ...state.storePickup.customerInfo,
            ...payload.customerInfo,
          },
        },
      };

    default:
      return state;
  }
};
